import { useCallback } from 'react';
import makeRequest from './axios';
import { retrieveToken } from '../services/auth';
import { getStoredWorkspace, getStoredOrg } from './workspace';
import { getSupergrowMetadata } from '../services/metadata';

export const useRequest = () => {
  // memoized the function, as otherwise if the hook is used inside
  // a useEffect, it will lead to an infinite loop
  const memoizedFn = useCallback(
    async (request) => {
      try {
        let tokenResponse = await retrieveToken();
        let token = tokenResponse.access_token;
        const accessToken = token;
        return makeRequest({
          ...request,
          headers: {
            ...request.headers,
            // Add the Authorization header to the existing headers
            Authorization: `Bearer ${accessToken}`,
            ProviderToken: tokenResponse.provider_token,
            WorkspaceID: getStoredWorkspace(),
            OrgID: getStoredOrg(),
            Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            'Supergrow-x-headers': btoa(JSON.stringify(getSupergrowMetadata())),
          },
        });
      }
      catch (err) {
        return makeRequest({
          ...request,
          headers: {
            ...request.headers,
            // Add the Authorization header to the existing headers
            Authorization: `Bearer ${"annymous"}`,
            WorkspaceID: getStoredWorkspace(),
          },
        });
      }
    },
    []
  );
  return {
    requestMaker: memoizedFn,
  };
};

export default useRequest;
